import router from "../router";
import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    isLoading: {
      requests: false,
      received: false,
      submitting: false,
    },
    requests: {
      pagination: {
        current_page: null,
        total: null,
        data: [],
      },
    },
    received: {
      pagination: {
        current_page: null,
        total: null,
        data: [],
      },
    },
    attachment: {
      id: null,
      file: null,
      progress: 0,
      uploading: false,
    },
    newReceivedCount: 0,
    exportReceivedReferralsLoading: false,
    orderVendors: {
      loading: false,
      data: [],
    },
  },
  mutations: {
    SET_UPLOAD_PROGRESS: (state, data) => {
      state.attachment.progress = data;
    },
    SET_UPLOADING: (state, data) => {
      state.attachment.uploading = data;
    },
    SET_FILENAME: (state, name) => {
      state.attachment.file = name;
    },
    SET_ATTACHMENT_ID: (state, id) => {
      state.attachment.id = id;
    },
    RESET_ATTACHMENT: (state) => {
      state.attachment.id = null;
      state.attachment.file = null;
      state.attachment.progress = 0;
    },
    PUSH_LIVE_ORDER: (state, data) => {
      state.requests.push(data);
    },
    SET_LOADING: (state, payload) => {
      state.isLoading[payload.obj] = payload.bool;
    },
    SET_RECEIVED_PAGINATION: (state, value) => {
      state.received.pagination = value;
    },
    SET_REQUESTS_PAGINATION: (state, value) => {
      state.requests.pagination = value;
    },
    SET_EXPORT_RECEIVED_REFERRALS_LOADING: (state, value) => {
      state.exportReceivedReferralsLoading = value;
    },
    SET_ORDERS_VENDORS_LOADING: (state, data) => {
      state.orderVendors.loading = data;
    },
    SET_ORDERS_VENDORS_DATA: (state, data) => {
      state.orderVendors.data = data;
    },
    SET_NEW_RECEIVED_COUNT: (state, count) => {
      state.newReceivedCount = count;
    },
  },
  actions: {
    allRequests: function ({ commit }, payload) {
      const vm = this;
      commit("SET_LOADING", { obj: "requests", bool: true });
      let url = `orders/requests?`;
      if (payload) {
        if (payload.limit) {
          url = `${url}limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
      }
      return new Promise((resolve) => {
        return vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload.limit || payload.page) {
                commit("SET_REQUESTS_PAGINATION", {
                  total: res.data.meta.total,
                  current_page: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_REQUESTS_PAGINATION", {
                  total: null,
                  current_page: null,
                  data: res.data.data,
                });
              }
              commit("SET_LOADING", { obj: "requests", bool: false });
              resolve(res.data.data);
            }
          })
          .catch((err) => {
            commit("SET_LOADING", { obj: "requests", bool: false });
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
    allReceived: function ({ commit }, payload) {
      const vm = this;
      commit("SET_LOADING", { obj: "received", bool: true });
      let url = `orders/received?`;
      for (const [key, value] of Object.entries(payload || {})) {
        url += `&${key}=${value}`;
      }
      return new Promise((resolve) => {
        return vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload.limit || payload.page) {
                commit("SET_RECEIVED_PAGINATION", {
                  total: res.data.meta.total,
                  current_page: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_RECEIVED_PAGINATION", {
                  total: null,
                  current_page: null,
                  data: res.data.data,
                });
              }
              commit("SET_LOADING", { obj: "received", bool: false });
              resolve(res.data.data);
            }
          })
          .catch((err) => {
            commit("SET_LOADING", { obj: "received", bool: false });
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
    newReceivedCount: function ({ commit }) {
      let vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .get("orders/new-received-count")
          .then((res) => {
            if (res.status == 200) {
              commit("SET_NEW_RECEIVED_COUNT", res.data);
              resolve(res.data);
            }
          })
          .catch(() => {
            commit("SET_NEW_RECEIVED_COUNT", 0);
            resolve(0);
          });
      });
    },
    updateStatus: function ({ commit, rootGetters }, payload) {
      commit("SET_SAVING_STATE", true, { root: true });
      payload.order.status = "Saving...";
      this.$http
        .put(
          `orders/${payload.id}/status`,
          {
            id: payload.id,
            status: payload.status,
          },
          {
            headers: rootGetters.headers,
          }
        )
        .then((res) => {
          if (res.status == 200) {
            payload.order.status = payload.status;
            commit("SET_SAVING_STATE", false, { root: true });
          }
        });
    },
    uploadAttachment: function ({ commit }, payload) {
      let formData = new FormData();
      formData.append(
        "attachmentData",
        payload.attachmentData,
        payload.attachmentData.name
      );
      formData.append("vendor_id", payload.vendor);
      formData.append("user_id", payload.user);
      commit("SET_UPLOADING", true);
      commit("SET_FILENAME", payload.attachmentData.name);

      this.$http
        .post("orders/upload-attachment", formData, {
          onUploadProgress: (uploadEvent) => {
            let progress = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
            commit("SET_UPLOAD_PROGRESS", progress);
          },
        })
        .then((res) => {
          if (res.status == 200) {
            commit("SET_UPLOADING", false);
            commit("SET_UPLOAD_PROGRESS", null);
            commit("SET_ATTACHMENT_ID", res.data.data.attachment);
          }
        })
        .catch((err) => {
          commit("SET_UPLOADING", false);
        });
    },
    setDueDate: function (context, payload) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .post(`orders/${payload.order.id}/due-date`, { due: payload.due })
          .then((res) => {
            if (res.status == 200) {
              resolve(true);
            }
          })
          .catch((e) => {
            resolve(false);
          });
      });
    },
    submitRating: function (context, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`orders/${payload.order.id}/rating`, {
            rating: payload.rating,
          })
          .then((res) => {
            if (res.status != 200) {
              return resolve(false);
            }
            return resolve(true);
          })
          .catch((err) => {
            if (err.data.message) {
              let title = err.data.message;
              context.dispatch(
                "setError",
                {
                  message: "",
                  title: title,
                },
                { root: true }
              );
            } else {
              //eslint-disable-next-line
              console.log(err);
            }
            resolve(false);
          });
      });
    },
    submitOrder: function (context, payload) {
      context.commit("SET_LOADING", { obj: "submitting", bool: true });
      //eslint-disable-next-line
      this.$http
        .post("orders", {
          order: payload.order,
          vendor: payload.vendor,
        })
        .then((res) => {
          if (res.status == 200) {
            context.commit("RESET_ATTACHMENT");
            context.commit("SET_LOADING", { obj: "submitting", bool: false });
            router.push("/orders");
          }
        })
        .catch((err) => {
          context.commit("SET_LOADING", { obj: "submitting", bool: false });
          let msg = [];
          if (err.data.message) {
            let title = err.data.message;
            Object.values(err.data.data).filter((e) => {
              msg.push(...e);
            });
            if (msg.length == 0) {
              msg = "";
            } else {
              msg = msg.join("<br>");
            }
            context.dispatch(
              "setError",
              {
                message: msg,
                title: title,
              },
              { root: true }
            );
          } else {
            //eslint-disable-next-line
            console.log(err);
            context.dispatch(
              "setError",
              {
                message:
                  "Something went wrong, please make sure you filled sub service field.",
                title: "Error",
              },
              { root: true }
            );
          }
        });
    },
    deleteAllRequests: function () {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete("orders/requests")
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    deleteSelectedRequests: function (_, ids) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("orders/delete-selected-requests", { ids })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    deleteRequest: function (_, id) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`orders/requests/${id}`)
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    deleteAllIncomingReferrals: function () {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete("orders/received")
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    deleteSelectedIncomingReferrals: function (_, ids) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("orders/delete-selected-received", { ids })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    deleteIncomingReferral: function (_, id) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`orders/received/${id}`)
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    readAllIncomingReferrals: function () {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("orders/read-all-received")
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    readSelectedIncomingReferrals: function (_, ids) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("orders/read-selected-received", { ids })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    readIncomingReferral: function (_, id) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`orders/read-received/${id}`)
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    exportReceivedReferrals: function ({ commit }, payload) {
      commit("SET_EXPORT_RECEIVED_REFERRALS_LOADING", true);
      const vm = this;
      let url = `orders/received/export?timezone=${payload.timezone}`;
      for (const [key, value] of Object.entries(payload || {})) {
        url += `&${key}=${value}`;
      }
      return new Promise((resolve) => {
        return vm.$http
          .get(url, { responseType: "arraybuffer" })
          .then((res) => {
            commit("SET_EXPORT_RECEIVED_REFERRALS_LOADING", false);
            resolve(res);
          })
          .catch((err) => {
            commit("SET_EXPORT_RECEIVED_REFERRALS_LOADING", false);
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
    getOrderVendors: function ({ commit }) {
      commit("SET_ORDERS_VENDORS_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        vm.$http
          .get(`orders/vendors`)
          .then((res) => {
            commit("SET_ORDERS_VENDORS_LOADING", false);
            if (res.status == 200) {
              commit("SET_ORDERS_VENDORS_DATA", res.data.data);
              resolve(res.data.data);
            }
          })
          .catch((err) => {
            commit("SET_ORDERS_VENDORS_LOADING", false);
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
  },
};
